// extracted by mini-css-extract-plugin
export default {"imageLink":"chat-photo_imageLink__kWjFy","image":"chat-photo_image__VmL0E"};